import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IAcademicGroups } from "./routeType";

const { key, getPath } = getApi("academicGroups.get");

type IExtractedRouteType = IAcademicGroups["academicGroupSingleRetrieve"];

export type IGetAcademicGroup = IPickSingleQuery<IExtractedRouteType>;

const getAcademicGroup: Fetcher<
  IGetAcademicGroup["response"],
  IGetAcademicGroup["variables"]
> = ({ academicGroupId, ...params }) => {
  return axiosClient.get(getPath({ academicGroupId }), { params });
};

export const useGetAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: getAcademicGroup,
});
